import { render, staticRenderFns } from "./JobsDataTable.vue?vue&type=template&id=dfba3b88"
import script from "./JobsDataTable.vue?vue&type=script&lang=js"
export * from "./JobsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports